import { OrderState } from "@/enum/orderState";
import { Address } from "./address";
import { Price } from "./price";
import { Shipment } from "./shipment";

export class Order {
  shoppingCartUUID?: string;
  id?: string;
  reference?: string;
  billingDetails?: BillingDetails;
  transferDetails?: string;
  orderState?: OrderState;
  cancellationState?: string;
  shipments?: Shipment[];
  paymentDate?: Date | null;
  totalPrice?: Price;
  shippingPrice?: Price;
  productsPrice?: Price;
  discountPrice?: Price;
  billingAddress?: Address | null;
  shippingAddress?: Address | null;
  eventHistory?: any;
  coupon?: any;
  lastEvent?: any;

  public static of(data: any): Order {
    const o: Order = new Order();

    o.id = data.id;
    o.shoppingCartUUID = data.shoppingCartUUID;
    o.reference = data.reference;
    o.billingDetails = BillingDetails.of(data.billingDetails);
    o.transferDetails = data.transferDetails;
    o.orderState = data.orderState;
    o.cancellationState = data.cancellationState;
    o.shipments = [];
    for (const shipment of data.shipments) {
      o.shipments.push(Shipment.of(shipment));
    }

    o.paymentDate = data?.paymentDate ? new Date(data?.paymentDate) : null;
    o.totalPrice = Price.of(data.totalPrice);
    o.shippingPrice = Price.of(data.shippingPrice);
    o.discountPrice = Price.of(data.discountPrice);
    o.productsPrice = Price.of(data.productsPrice);
    o.shippingAddress = data.shipments[0].address ? Address.of(data.shipments[0].address) : null;
    o.billingAddress = data.billingAddress ? Address.of(data.billingAddress) : null;
    o.eventHistory = EventHistory.of(data.eventHistory, o.shipments);
    o.coupon = data.coupon ? Coupon.of(data.coupon) : null;
    o.lastEvent = Object.values(o.eventHistory)[Object.values(o.eventHistory).length - 1];
    return o;
  }
}

export class Coupon {
  cartPriceRuleId?: string;
  code?: string;
  description?: string;
  id?: string;
  name?: string;

  public static of(data: any) {
    const c = new Coupon();

    c.cartPriceRuleId = data.cartPriceRuleId;
    c.code = data.code;
    c.description = data.description;
    c.id = data.id;
    c.name = data.name;

    return c;
  }
}

export class EventHistory {
  PROCESSING?: any;
  SHIPPED?: any;
  ESTIMATE?: any;
  SHOPPING_CART?: any;
  CANCELLED?: any;
  ESTIMATE_CANCELLED?: any;
  PAYMENT_FAILED?: any;
  PAYMENT_PENDING?: any;
  PENDING?: any;
  PREPARING?: any;

  public static of(eventHistory: any, shipments?: Shipment[]): EventHistory {
    const e = new EventHistory();

    if (eventHistory["PROCESSING"]) {
      e.PROCESSING = { title: "PROCESSING", date: eventHistory["PROCESSING"] };
    }
    if (eventHistory["PAYMENT_PENDING"]) {
      e.PAYMENT_PENDING = { title: "PAYMENT_PENDING", date: eventHistory["PAYMENT_PENDING"] };
    }
    if (eventHistory["ESTIMATE"]) {
      e.ESTIMATE = { title: "ESTIMATE", date: eventHistory["ESTIMATE"] };
    }
    if (eventHistory["ESTIMATE_CANCELLED"]) {
      e.ESTIMATE_CANCELLED = { title: "ESTIMATE_CANCELLED", date: eventHistory["ESTIMATE_CANCELLED"] };
    }
    if (eventHistory["PREPARING"]) {
      e.PREPARING = { date: eventHistory["PREPARING"] };
    }
    if (eventHistory["PENDING"]) {
      e.PENDING = { title: "PENDING", date: eventHistory["PENDING"] };
    }
    if (eventHistory["PAYMENT_FAILED"]) {
      e.PAYMENT_FAILED = { title: "PAYMENT_FAILED", date: eventHistory["PAYMENT_FAILED"] };
    }
    if (eventHistory["CANCELLED"]) {
      e.CANCELLED = { title: "CANCELLED", date: eventHistory["CANCELLED"] };
    }
    if (eventHistory["SHOPPING_CART"]) {
      e.SHOPPING_CART = { title: "SHOPPING_CART", date: eventHistory["SHOPPING_CART"] };
    }
    if (eventHistory["SHIPPED"]) {
      const trackings: any = [];
      shipments?.forEach((s: Shipment) => {
        trackings.push({ number: s?.trackingInfo?.trackingNumber, url: s?.trackingInfo?.trackingUrl });
      });
      e.SHIPPED = { title: "SHIPPED", date: new Date(), trackings };
    }

    return Object.entries(e)
      .sort((a: any, b: any) => new Date(a[1].date).getTime() - new Date(b[1].date).getTime())
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  }
}

export class BillingDetails {

  paymentMethod?: string;
  transactionNumber?: string;

  public static of(data: any): BillingDetails {
    const b: BillingDetails = new BillingDetails();

    b.paymentMethod = data?.paymentMethod;
    b.transactionNumber = data?.transactionNumber;
    return b;
  }
}